<div class="header">
  <app-breadcrumb></app-breadcrumb>
  <div class="system-status">
    <div class="status-trigger" (click)="toggleSystemStatus()">
      <span class="status-dot" [class.offline]="!isNetworkOnline"></span>
      <span>{{ (isNetworkOnline ? "ALL_SYSTEMS_OPERATIONAL" : "SYSTEM_ISSUES_DETECTED") | translate }}</span>
    </div>
    @if(isSystemStatusOpen){
    <div class="overlay-light" (click)="toggleSystemStatus()"></div>
    <div class="status-container">
      <div class="item d-flex justify-content-between align-items-center">
        <span>{{ "IPSEC" | translate }}</span>
        <span class="status-dot" [class.offline]="!isNetworkOnline"></span>
      </div>
    </div>
    }
  </div>
  <ul class="user-info" (click)="toggleProfileModal()">
    <li class="role">{{ role! | translate }}</li>
    <li class="name ps-2">{{ name }}</li>
    <li class="ps-2">
      @if (image === "/" || !image) {
      <img src="assets/header/user-icon.svg" alt="User" height="20" width="20" />
      } @else {
      <img src="data:image/png;base64,{{ image }}" alt="User" class="circle-img" />
      }
    </li>
  </ul>
  @if(isProfileOpen){
  <div class="overlay-light" (click)="toggleProfileModal()">
    <div class="profile-container">
      <div class="item p-2 d-flex justify-content-between align-items-center" [routerLink]="['/account/profile']">
        <span class="pe-2 ps-2">{{"PROFILE" | translate}}</span>
        <svg-icon class="pe-2" alt="User Details" src="assets/device/edit.svg"></svg-icon>
      </div>
      <div class="item p-2 d-flex justify-content-between align-items-center" (click)="isLogoutModalOpen = true">
        <span class="pe-2 ps-2">{{"LOGOUT" | translate}}</span>
        <svg-icon class="pe-2" alt="Logout" src="assets/account/logout.svg"></svg-icon>
      </div>
    </div>
  </div>
  }
</div>

<app-confirm-dialog *ngIf="isLogoutModalOpen" titleKey="LOGOUT" question="LOGOUT_MODAL"
  (confirm)="logOut()" (cancel)="isLogoutModalOpen = false"></app-confirm-dialog>